class VacantJobs {

	constructor( elem ) {
		this.items = Array.prototype.slice.call(elem[0].querySelectorAll('.vacant-jobs__card'))
		this.setHeights()
		window.addEventListener('resize', () => this.setHeights())
	}

	setHeights() {
		this.items.forEach(item => {
			item.style.minHeight = 0 + 'px'
		})

		const highest = Math.max.apply(Math, this.items.map((item) => item.clientHeight))

		this.items.forEach(item => {
			item.style.minHeight = highest + 2 + 'px'
		})
	}
}

export default VacantJobs

